export function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export function kebabToPascalCase(input) {
  const words = input.split('-');

  return words.map(capitalize).join('');
}
